module.exports = __webpack_public_path__ + "static/media/invoice.1928bede.png";